<template>
  <div class="FlowInteraction">
    <!-- <pre style="color:white;margin: 1em 0;">isLocked {{ isLocked }} isCompleted {{ isCompleted }}</pre> -->
    <b-button
      v-if="!isFirst"
      variant="outline-light"
      size="sm"
      class="previous"
      :disabled="isDisabled"
      @click.prevent.stop="handlePrevious"
    >
      {{ $t('processes.previous_step') }}
    </b-button>
    <template v-if="!isLocked">
      <span
        id="save"
        class="d-flex"
      >
        <b-button
          variant="outline-light"
          size="sm"

          :disabled="isDisabled || !isLocationConnected || disableSaveBtn"
          @click.prevent.stop="handleSave"
        >
          {{ $t('processes.save') }}
        </b-button>
        <b-tooltip
          v-if="!isLocationConnected"
          target="save"
          variant="danger"
        >
          {{ disconnectedLocationMessage }}
        </b-tooltip>
      </span>
      <b-button
        v-if="isRecordSaved && (isStepCompleted || isCompleted)"
        variant="outline-light"
        size="sm"
        :disabled="isDisabled"
        @click.prevent.stop="handleCancelChange"
      >
        {{ $t('processes.cancel') }}
      </b-button>
      <span
        id="next"
        class="d-flex"
      >
        <b-button
          v-if="showNextButton && !isLast"
          variant="light"
          size="sm"
          :disabled="isDisabled || isDisabledNextButton || !isLocationConnected"
          @click.prevent.stop="handleSubmitAndNext"
        >
          {{ $t('processes.next_step') }}
        </b-button>
        <b-tooltip
          v-if="!isLocationConnected"
          target="next"
          variant="danger"
        >
          {{ disconnectedLocationMessage }}
        </b-tooltip>
      </span>
      <b-button
        v-if="isLast && !isCompleted"
        variant="light"
        size="sm"
        :disabled="isDisabled || isDisabledNextButton"
        @click.prevent.stop="handleComplete"
      >
        {{ $t('processes.finish') }}
      </b-button>
    </template>

    <template v-else-if="canEdit && isStepCompleted">
      <b-button
        variant="outline-light"
        size="sm"
        :disabled="isDisabled"
        @click.prevent.stop="handleStartCorrection"
      >
        {{ $t('processes.correction') }}
      </b-button>
      <b-button
        v-if="isOpenForChange && !isLast"
        variant="outline-light"
        size="sm"
        :disabled="isDisabled"
        @click.prevent.stop="handleStartChange"
      >
        {{ $t('processes.edit') }}
      </b-button>
      <b-button
        v-if="showNextButton && !isLast"
        variant="light"
        size="sm"
        :disabled="isDisabled || isDisabledNextButton"
        @click.prevent.stop="handleNext"
      >
        {{ $t('processes.next_step') }}
      </b-button>
    </template>

    <template v-else-if="showNextButton && !isLast">
      <b-button
        variant="light"
        size="sm"
        :disabled="isDisabled || !isStepCompleted"
        @click.prevent.stop="handleNext"
      >
        {{ $t('processes.next_step') }}
      </b-button>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    /**
     * UI context
     */
    first: {
      type: Boolean,
      default: false,
    },
    last: {
      type: Boolean,
      default: false,
    },

    showNextButton: {
      type: Boolean,
      default: true
    },

    /**
     * Record Context
     */
    step: {
      type: [Number, String],
      required: true,
    },
    currentStep: {
      type: [Number, String],
      required: true,
    },
    locked: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    completed: {
      type: Boolean,
      required: true,
    },
    disableNextBtn: {
      type: Boolean,
      required: true,
    },
    mayEdit: {
      type: Boolean,
      required: true,
    },
    openForChange: {
      type: Boolean,
      required: true,
    },

    isCompletedStep: {
      type: Boolean,
      default: false,
    },
    isAvailableStep: {
      type: Boolean,
      default: true,
    },
    locationConnected: {
      type: Boolean,
      default: true,
    },
    disableSaveBtn: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isLocked: false
    }
  },
  computed: {
    ...mapGetters('processes', ['getRecordLocked']),
    disconnectedLocationMessage () {
      return this.$i18n.t('RealisationHeader.disconnectedLocationMessage')
    },
    isStepCompleted () {
      return !!this.isCompletedStep
    },
    isDisabled () {
      return this.disabled
    },
    canEdit () {
      return this.mayEdit
    },
    isLocationConnected () {
      return this.locationConnected
    },
    isFirst () {
      return this.first
    },
    isLast () {
      return this.last
    },
    isCompleted () {
      return this.completed
    },
    isDisabledNextButton () {
      return this.disableNextBtn
    },
    isOpenForChange () {
      return this.openForChange
    },
    isRecordSaved () {
      return this.record?.ref
    }
  },
  watch: {
    isStepCompleted: {
      immediate: true,
      handler (value) {
        this.isLocked = value
      }
    },
    locked: {
      immediate: true,
      handler (locked) {
        this.isLocked = locked
      }
    },
    // This should be in the parent or one of the mixins but no time for it now //
    step: {
      immediate: true,
      handler (step) {
        if (!this.isLocationConnected) {
          this.handleCancelChange()
        }
        const CPOAdviceDecision = this.record.CurrentLocation?.CPOAdvice?.CPOAdvice
        if (step === 3 && CPOAdviceDecision && CPOAdviceDecision !== 'yes') {
          this.isLocked = true
        }
      }
    },
    getRecordLocked: {
      handler (bool) {
        this.isLocked = bool
      }
    }
  },
  methods: {
    handleNext() {
      this.$emit('handleNext')
    },
    handlePrevious() {
      this.$emit('handlePrevious')
    },
    handleSubmitAndNext() {
      this.$emit('handleSubmitAndNext')
      this.isLocked = this.locked
    },
    handleCancelChange() {
      this.isLocked = true
      this.$emit('handleCancelChange')
    },
    handleStartCorrection() {
      this.isLocked = false
      this.$emit('handleStartCorrection')
    },
    handleStartChange() {
      this.isLocked = false
      this.$emit('handleStartChange')
    },
    handleComplete() {
      this.$emit('handleComplete')
    },
    handleSave() {
      this.$emit('handleSubmit')
      // Lock it only by existing record (not by new process) //
      this.isLocked = this.record?.ref
    },
  },
}
</script>

<style>
.FlowInteraction {
  display: flex;
  gap: 0.7em;
}
</style>
